import { Help, HelpPanelColor, HelpParameters } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { RewardColor } from "../../slot/ScatterRandomAward/RewardOptionFactory";
import { SlotGameInitData } from "../../SlotGameInitData";
import { FGPickElemState, FreegamePickElement } from "../FreegameBonus/FreegamePickElement";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
import { ChangeSpeedParams, SlotGameType1 } from "../SlotGameType1";
// namespace SlotGames
// namespace SlotGames
// {

	export class StickyChilli extends SlotGameType1 {

		//protected override freegameBonusFactory: FreegameBonusFactory = new StickyChilliFreegameBonusFactory();
		protected override pickBonusFactory:PickBonusFactory = new StickyChilliPickBonusFactory();
		
		//protected panelFactory:IPanelFactory = new StickyChilliPanelFactory();
		protected override helpFactory:IHelpFactory = new StickyChilliHelpFactory();
		//LED COLOR
		protected override ColorLed:string="255,64,0\n";
	
		//SEND COLOR 
        protected override color: RewardColor = 
        {
            color: "white",
		    coloroutherStroke: "black",
            colorinnerStroke: "purple",
        }

		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "StickyChilli");;

			this.spinnableReelsParams.topBorderWidth = 8;
			this.spinnableReelsParams.bottomBorderWidth = 8;
		}

		// public PrepareFont(resourceManager: ResourceManager)
		// {
		//  resourceManager.Add(new FontResource(this.basepath + "resources/MexicanTequila.ttf",this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
		// }
		
	}

	// class StickyChilliFreegame extends FreegameBonus
	// {
	// 	protected shotSprite: CanvasSprite = null;
	// 	protected gunSprite: CanvasSprite = null;
	// 	public constructor(gameName: string, params: FreegameBonusParams ) {
	// 		super(gameName, params);
	// 		this.spinnableReelsParams.topBorderWidth = 8;
	// 		this.spinnableReelsParams.bottomBorderWidth = 8;
	// 	}

	// 	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void>
	// 	{
	// 		super.PrepareResources(resourceManager);

	// 		this.ShotPrepare(resourceManager);
	// 		this.GunPrepare(resourceManager);

	// 	}

	// 	public override AudioPrepare(resourceManager:ResourceManager)
	// 	{
	// 		super.AudioPrepare(resourceManager);
	// 		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/GunShot" + Settings.audiFormat, this.resid.ScopedResourceName("gunshot")));
	// 	}


	// 	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
	// 	{
	// 		await super.ResourcesLoaded(resourceManager);

	// 		this.ShotLoaded(resourceManager);
	// 		this.GunLoaded(resourceManager);

	// 		//this.pickElem.innerHTML = "BOTTLE";


	// 		this.pickIntroMessageContainer.style.color = "yellow";
			
	// 		this.pickIntroMessageContainer.style.webkitTextStrokeWidth = "2px";
	// 		this.pickIntroMessageContainer.style.webkitTextStrokeColor = "black";
	// 		this.pickedMessageContainer.style.webkitTextStrokeWidth="2px";
	// 		this.pickedMessageContainer.style.webkitTextStrokeColor = "black";
	// 		this.finalMessageContainer.style.webkitTextStrokeWidth="2px";
	// 		this.finalMessageContainer.style.webkitTextStrokeColor = "black";
			
	// 		SetStyles(this.view.querySelector(".pickInstructions"),
	// 		{
	// 			top:"49px",
	// 			fontSize:"62px",
	// 			position:"relative",
	// 		});

	// 	}

	// 	protected override PrepareFonts(resourceManager: ResourceManager): void {
	// 		resourceManager.Add(new FontResource(this.params.commonBonusResourcesBasePath + "resources/newzone.ttf", this.resid.ScopedResourceName("bigwincount")));
	// 		resourceManager.Add(new FontResource(this.params.gameBonusResourcesBasePath + "MexicanTequila.ttf", "." + this.resid.ScopedResourceName(["lines", "font"])));
	// 	}
		

	// 	protected override PicksPositions(): FreegamePickElemGeometry[] 
	// 	{
	// 		// align award to be in the box, when box opens
	// 		let geometry: FreegamePickElemGeometry[] = [];


	// 		let displayWidth: number = 250;
	// 		let displayHeight: number = 500;

	// 		let displayRects: PixelRect[] = 
	// 		[
	// 			new PixelRect(374, 98, displayWidth, displayHeight),
	// 			new PixelRect(589, 206, displayWidth, displayHeight),
	// 			new PixelRect(828, 110, displayWidth, displayHeight),
	// 			new PixelRect(1060, 203, displayWidth, displayHeight),
	// 			new PixelRect(1293, 112, displayWidth, displayHeight),
	// 		];

	// 		// offset relative to pick rect
	// 		let pickRect = new PixelRect(56, 64, 150, 370);
	// 		let awardRect = new PixelRect(71, 100, 150, 370);

	// 		for (let i = 0; i < displayRects.length; i++) 
	// 		{
	// 			geometry.push(new FreegamePickElemGeometry(displayRects[i], pickRect, awardRect));
	// 		}

	// 		return geometry;
	// 	}


	// 	protected ShotPrepare(resourceManager: IWriteOnlyResourceManager): void 
	// 	{
	// 		resourceManager.Add(new SpriteResource(this.params.gameBonusResourcesBasePath + "shot", this.resid.Add("shot"), true, this.logGroup.Add("shot"), true));
	// 	}

	// 	protected ShotLoaded(resourceManager: IReadOnlyResourceManager): void
	// 	{
	// 		let sprite: Sprite = resourceManager.Get<SpriteResource>(this.resid.Add("shot")).sprite;

	// 		this.shotSprite = new CanvasSprite(sprite, sprite.Size(), true, CanvasSpriteSizing.Stretch);
	// 		//this.shotSprite.AddOnCompleteCallback(()=> this.shotSprite.Hide());
	// 		SetStyles(this.shotSprite.View(), {
	// 			position: "absolute",
	// 			pointerEvents: "none",
	// 			touchAction: "none"
	// 		});

	// 		this.picksContainer.appendChild(this.shotSprite.View());
	// 		this.shotSprite.Hide();
	// 	}

	// 	protected GunPrepare(resourceManager: IWriteOnlyResourceManager): void 
	// 	{
	// 		resourceManager.Add(new SpriteResource(this.params.gameBonusResourcesBasePath + "gun", this.resid.Add("gun"), true, this.logGroup.Add("gun"), true));
	// 	}

	// 	protected GunLoaded(resourceManager: IReadOnlyResourceManager): void
	// 	{
	// 		let sprite: Sprite = resourceManager.Get<SpriteResource>(this.resid.Add("gun")).sprite;
	// 		this.gunSprite = new CanvasSprite(sprite, sprite.Size());

	// 		this.gunSprite.View().style.position = "absolute";
	// 		this.gunSprite.View().style.right = "0px";
	// 		this.gunSprite.View().style.bottom = "0px";
	// 		this.gunSprite.Show();

	// 		this.picksContainer.appendChild(this.gunSprite.View());
	// 	}


	// 	public override Update():void
	// 	{
	// 		super.Update();

	// 		if(this.stateMachine.State() == FreegameStates.Pick)
	// 		{
	// 			this.shotSprite.Update();
	// 			this.gunSprite.Update();
	// 		}
	// 	}

	// 	public override OnPicked(index: number):void
	// 	{
	// 		if (this.stateMachine.State() == FreegameStates.Pick)
	// 		{

	// 			// Log.Debug(this.logGroup, "Picked index " + index);

	// 			this.audio.Play(this.resid.ScopedResourceName("gunshot"));

	// 			// TODO check state, check index bounds
	// 			this.pickedIndex = index;
	// 			// protocol.Send("SelectBonusElement",{selectedElement: index});

	// 			for (let i = 0; i < this.picks.length; i++) {
	// 				if (i == index) {
	// 					this.picks[i].BringToFront();
	// 				}
	// 				else {
	// 					this.picks[i].PushToBack();
	// 				}
	// 			}
				

	// 			let centerY:number = this.picks[index].PickRect().y + (this.picks[index].PickRect().height /2)+ this.picks[index].DisplayRect().y;
	// 			let centerX:number = this.picks[index].PickRect().x + (this.picks[index].PickRect().width/2) + this.picks[index].DisplayRect().x;

				
				
	// 			this.shotSprite.View().style.top = centerY+"px";
	// 			this.shotSprite.View().style.left = centerX+"px";

	// 			this.shotSprite.SetSize(new Size((1920)- centerX- this.gunSprite.canvas.view.width/2, 1080-centerY - (this.gunSprite.canvas.view.height/1.2)));

	// 			this.gunSprite.Start(false);
				

	// 			this.shotSprite.Start(false);
	// 			this.shotSprite.Show();

	// 			setTimeout(()=> this.stateMachine.ChangeState(FreegameStates.RevealPicked), 1000);
	// 		}
	// 	}

	// }

	class StickyChilliFreegamePickElement extends FreegamePickElement
	{
		public override OnPickedBegin()
		{
			setTimeout(() => this.stateMachine.ChangeState(FGPickElemState.WaitDisplayAward),500);
		}

		public override OnNotPickedBegin()
		{
			setTimeout(() => this.stateMachine.ChangeState(FGPickElemState.WaitDisplayRemainig),500);
		}

		public override OnWaitToPickBegin(): void
		{}
		protected override AnimPrepare(): void 
		{}

		protected override WaitPickAnimPrepare(): void 
		{}
	}


	// class StickyChilliFreegameBonusFactory extends FreegameBonusFactory
	// {
	// 	public override CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus 
	// 	{
	// 		return new StickyChilliFreegame(gameName, params);
	// 	}

	// 	public override CreatePickElement(params: FreegamePickElementParams): FreegamePickElement 
	// 	{
	// 		return new StickyChilliFreegamePickElement(params);
	// 	}
	// }

	//Panel Colorized
		class StickyChilliPanelFactory implements IPanelFactory
	{
		public CreateNewPanel(params: PanelParams):Panel
		{
			return new StickyChilliPanel(params);
		}
	}

	class StickyChilliPanel extends Panel
	{
		protected override ButtonBackground():ButtonColors
		{
			let color:ButtonColors = {
				backgroundButtonColor: "linear-gradient(rgb(64, 21, 21),rgb(140, 4, 4), rgb(191, 6, 6),rgb(140, 4, 4),rgb(64, 21, 21)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				linearColor:"linear-gradient(to left , transparent, yellowgreen,transparent ) 0 10 100%",
			};

			return color;
		}
	}


	//Help Colorized
	class StickyChilliHelpFactory implements IHelpFactory
	{
		public CreateNewHelp(params: HelpParameters):Help
		{
			return new StickyChilliHelp(params);
		}
	}

	class StickyChilliHelp extends Help
	{
		protected override BackgroundPanel():HelpPanelColor
		{
			let color:HelpPanelColor = {
				backgroundPanelColor: "linear-gradient(rgb(64, 21, 21),rgb(140, 4, 4), rgb(191, 6, 6),rgb(140, 4, 4),rgb(64, 21, 21)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			};

			return color;
		}
	}

	/**
	 * PICK BONUS 
	 */
	class StickyChilliPickBonus extends PickBonus
	{
		public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
			throw new Error("Method not implemented.");
		}


	}

	class StickyChilliPickBonusElement extends PickBonusElement
	{
	}

	class StickyChilliPickBonusFactory extends PickBonusFactory
	{
		public override CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus 
		{
			return new StickyChilliPickBonus(gameName, params);
		}

		public override CreatePickElement(params: PickBonusPickElementParams): PickBonusElement 
		{
			return new StickyChilliPickBonusElement(params);
		}
		
	}
// }
